import { render, staticRenderFns } from "./backgroundTopUpOrder.vue?vue&type=template&id=484997e0&scoped=true&"
import script from "./backgroundTopUpOrder.vue?vue&type=script&lang=js&"
export * from "./backgroundTopUpOrder.vue?vue&type=script&lang=js&"
import style0 from "./backgroundTopUpOrder.vue?vue&type=style&index=0&id=484997e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484997e0",
  null
  
)

export default component.exports